<template>
  <div>
    <v-app-bar color="#3a3a3a" dark flat fixed>
      <v-toolbar-title>HP Survey App</v-toolbar-title>
      <!-- <v-spacer style="z-index: 1"></v-spacer> -->
      
      <v-toolbar-items>
        <v-btn color="#c0c700" class="float-left ml-15" text to="/">Workshop</v-btn>
        <v-btn color="#c0c700" class="float-left" text to="/coachingsurvey">Coaching</v-btn>
        <v-speed-dial
          style="right: 20px; top: 10px;"
          fixed
          v-model="fab"
          :direction="direction"
          :open-on-hover="hover"
          :transition="transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="blue darken-2" dark fab small>
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-account-circle</v-icon>
            </v-btn>
          </template>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                small
                color="green"
                href="https://hpapps.healthyperformance.co.uk/profile"
                target="_blank"
                v-on="on"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Update profile</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                small
                color="orange"
                href="https://hpapps.healthyperformance.co.uk/changepassword"
                target="_blank"
                v-on="on"
              >
                <v-icon>mdi-lock-open-outline</v-icon>
              </v-btn>
            </template>
            <span>Change password</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                dark
                small
                color="indigo"
                href="https://hpapps.healthyperformance.co.uk/users"
                target="_blank"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Add user</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn fab dark small color="red" @click="onSignOut()" v-on="on">
                <v-icon>exit_to_app</v-icon>
              </v-btn>
            </template>
            <span>Logout</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar-items>
    </v-app-bar>

    <v-container>
      <slot />
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
import { hpUser } from "../classes/hpUser";
export default {
  methods: {
    onSignOut() {
      Auth.signOut()
        .then(data => {
          this.$router.push({ path: "login" });
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(err => console.log(err));
    }
  },
  data: () => ({
    direction: "bottom",
    hover: false,
    transition: "slide-y-reverse-transition",
    fab: false,
    isValidOperations: false,
    isConsultantRole: false
  }),
  created() {
    const that = this;
    let hpUserObj = new hpUser();
    hpUserObj.getUserRoles().then(userRole => {
      userRole.forEach(function(role) {
        const accessRoles = ["ADMIN", "SERVICE"];
        if (accessRoles.includes(role)) {
          that.isConsultantRole = true;
        }
      });
    });
  }
};
</script>

<style scoped>
@import "../assets/style.css";
</style>